<template>
    <tr>
        <td class="editor-content editor-label">View</td>
        <td class="editor-content">

            <div class="btn-group dropleft">
                <button class="btn btn-light btn-sm dropdown" type="button" data-bs-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                    {{linkLocationLabel}}
                </button>
                <div class="dropdown-menu">
                    <div v-if="model.app.id" class="dropdown-divider"></div>
                    <h6 class="dropdown-header">Views</h6>

                    <a v-for="view in views" class="dropdown-item" href="javascript:void(0)"
                       @click="onViewLinkSelected(view)"
                       :class="isActiveViewLink(view) ? 'active' : ''">{{view.name}}</a>

                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="javascript:void(0)" @click.stop="onUrlSelected()"
                       :class="selectedComponent.resourceType === 'URL' ? 'active' : ''">URL</a>
                    <div class="dropdown-divider"></div>

                    <div v-show="urlVisible" class="form-group">
                        <input type="text" class="form-control" id="viewUrlInput" placeholder="https://"
                               v-model="selectedComponent.resource">
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'ViewLinkProperties',
        props: ['selectedComponent', 'view'],
        computed: {
            urlVisible() {
                return this.selectedComponent.resourceType === 'URL'
            },
            linkLocationLabel() {
                return this.selectedComponent.resource ? this.selectedComponent.resource : 'select'
            },
            views() {
                let appViews = webase.managers.app.getViews()
                return appViews.filter(view => view.id !== this.view.id)
            },
        },
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            isActiveViewLink(view) {
                return this.selectedComponent.resourceType === "View" && this.selectedComponent.resource === view.id
            },
            onViewLinkSelected(view) {
                this.selectedComponent.resourceType = "View"
                this.selectedComponent.resource = view.id
            },
            onUrlSelected() {
                this.selectedComponent.resourceType = "URL"
                this.selectedComponent.resource = ''
            }
        }
    }
</script>

<style>

</style>
